var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"Input/Date","transform":"translate(-150.000000, -39.000000)"},React.createElement("g",{"id":"Group","transform":"translate(150.000000, 39.000000)"},[React.createElement("rect",{"id":"Rectangle-22","fill":"#D8D8D8","x":"0","y":"0","width":"22","height":"19","key":0}),React.createElement("rect",{"id":"Rectangle-22-Copy","fill":"#FFFFFF","x":"4","y":"7","width":"14","height":"9","key":1})])))]);
}

Calendar.defaultProps = {"width":"22px","height":"19px","viewBox":"0 0 22 19","version":"1.1"};

module.exports = Calendar;

Calendar.default = Calendar;
